import { fetchWithRetry } from '@tunein/web-utils';
import { noop } from 'es-toolkit';
import { fallbackValues, L10N_DICTIONARY_URL } from '../constants';
import { getExperiment } from '../singletons';
import { debug } from '../utils';
const DEFAULT_L10N_URL = 'https://cdn-web.tunein.com/assets/l10n/default.json';
class LocalizationsProvider {
    #localeToLocalizationsMap = {};
    #localizations;
    #locale = 'en';
    get locale() {
        return this.#locale;
    }
    async init(options) {
        if (options.localizations) {
            this.#localizations = options.localizations;
            this.setLocale(options.locale);
            return;
        }
        this.setLocale(options.locale);
        const url = getExperiment(L10N_DICTIONARY_URL, DEFAULT_L10N_URL);
        this.#localeToLocalizationsMap = await fetchWithRetry(url).catch(noop);
        this.#localizations = this.#localeToLocalizationsMap?.[this.#locale];
    }
    setLocale(locale) {
        const newLocale = locale ? locale.split('-').shift()?.toLowerCase() : this.#locale;
        if (!this.#localeToLocalizationsMap) {
            this.#locale = newLocale;
            return;
        }
        if (this.#localeToLocalizationsMap[newLocale]) {
            this.#locale = newLocale;
            this.#localizations = this.#localeToLocalizationsMap[newLocale];
            debug('Locale set to', newLocale);
            return;
        }
        if (newLocale !== this.#locale) {
            debug(`Locale ${newLocale} not supported, falling back to ${this.#locale}`);
        }
    }
    get(key, fallback) {
        return this.#localizations?.[key] || fallback || fallbackValues[key] || key;
    }
}
export const localizationsProvider = new LocalizationsProvider();
